import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider } from '../../hooks/useTheme';
import '../../asset/css/main.css';

export default function Login() {
  return (
    <ThemeProvider>
      <LoginContent />
    </ThemeProvider>
  );
}

function LoginContent() {
  const [role,    setRole]    = useState('contestant');
  const [email,   setEmail]   = useState('');
  const [pass,    setPass]    = useState('');
  const [showPw,  setShowPw]  = useState(false);
  const [remember,setRemember]= useState(false);
  const navigate = useNavigate();
  const isJudge  = role === 'judge';

  const handleLogin = () => {
    if (isJudge) navigate('/judge/dashboard');
    else          navigate('/contestant/dashboard');
  };

  return (
    <div className="login-shell">
      {/* ── Left visual ── */}
      <div className="login-visual">
        <div className="lv-bg" />
        <div className="lv-overlay" />

        <div className="lv-logo">
          <span className="lv-logo-icon">♪</span>
          <span className="lv-logo-text">SoundBattle</span>
        </div>

        <div>
          <h1 className="lv-headline">
            YOUR<br />
            <span className="lv-stroke">STAGE</span><br />
            AWAITS
          </h1>
          <p className="lv-sub">Upload your music, face the world's best, and claim your glory. Season 4 — $50,000 prize pool.</p>
        </div>

        <div className="lv-stats">
          {[['48K+','Artists'],['$50K','Prize Pool'],['200+','Judges']].map(([v, l]) => (
            <div className="lv-stat" key={l}><strong>{v}</strong><span>{l}</span></div>
          ))}
        </div>
      </div>

      {/* ── Right form ── */}
      <div className="login-form-wrap">
        <div className="login-box anim-up">
          <div className="lf-title">Welcome Back</div>
          <div className="lf-sub">Sign in to your SoundBattle account</div>

          {/* Role toggle */}
          <div className="role-toggle">
            <button className={`role-btn${role === 'contestant' ? ' act-c' : ''}`} onClick={() => setRole('contestant')}>
              🎤 Contestant
            </button>
            <button className={`role-btn${role === 'judge' ? ' act-j' : ''}`} onClick={() => setRole('judge')}>
              🎧 Judge
            </button>
          </div>

          {isJudge && (
            <div className="judge-hint">
              <span>🔐</span>
              <span>Judge accounts are invitation-only. Your login link was sent to your registered email by the panel committee.</span>
            </div>
          )}

          {/* Email */}
          <div className="fg">
            <label className="flabel">Email Address</label>
            <input
              className={`finput${isJudge ? ' gold' : ''}`}
              type="email"
              placeholder={isJudge ? 'judge@example.com' : 'you@example.com'}
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>

          {/* Password */}
          <div className="fg">
            <label className="flabel">Password</label>
            <div className="lf-pw-wrap">
              <input
                className={`finput${isJudge ? ' gold' : ''}`}
                type={showPw ? 'text' : 'password'}
                placeholder="••••••••"
                value={pass}
                onChange={e => setPass(e.target.value)}
                style={{ paddingRight: '3rem' }}
              />
              <button className="lf-eye" onClick={() => setShowPw(p => !p)} type="button">
                {showPw ? '🙈' : '👁'}
              </button>
            </div>
          </div>

          {/* Remember / forgot */}
          <div className="lf-row">
            <label className="lf-check">
              <input type="checkbox" checked={remember} onChange={e => setRemember(e.target.checked)} />
              Remember me
            </label>
            <a className="lf-forgot" href="#">Forgot password?</a>
          </div>

          {/* Submit */}
          <button className={`btn-login ${isJudge ? 'j' : 'c'}`} onClick={handleLogin}>
            Sign In as {isJudge ? 'Judge' : 'Contestant'}
          </button>

          {/* Social login — contestant only */}
          {!isJudge && (
            <>
              {/* <div className="lf-divider"><span>or continue with</span></div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'0.7rem', marginBottom:'1.25rem' }}>
                {[['🎵','Spotify'],['G','Google']].map(([ico, lbl]) => (
                  <button key={lbl} className="btn btn-ghost" style={{ fontSize:'0.84rem' }}>
                    <span>{ico}</span>{lbl}
                  </button>
                ))}
              </div> */}
              <div className="lf-signup">Don't have an account? <a href="#">Sign up free</a></div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}